import React, { useState, useRef } from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { parsePhoneNumberFromString, AsYouType } from 'libphonenumber-js'
import FormInput from './FormInput'
import Button from './Button'
import Spinner from './Spinner'
import SettingsCheckbox from './SettingsCheckbox'
import SettingsPhone from './SettingsPhone'
import { getAccount, patchAccount, patchEmailIdentities, deletePhoneNumber } from '../actions/api'
import { profileSelector } from '../reducers/profile'
import CountriesData from '../constants/Countries'
import find from 'lodash/find'
import get from 'lodash/get'
import reject from 'lodash/reject'

function PersonalDataForm({ profile, getAccount, patchAccount, patchEmailIdentities, deletePhoneNumber }) {
  const getCodeEl = useRef(null)

  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState([])
  const [error, setError] = useState(null)

  const [name, setName] = useState(get(profile, 'name') || '')
  const [email, setEmail] = useState(get(profile, 'email') || '')
  const [newsletter, setNewsletter] = useState(get(profile, 'newsletter') || false)

  const handleNameChange = event => {
    setName(event.target.value)
    setErrors(reject(errors, { type: 'name' }))
  }

  const handleEmailChange = event => {
    const value = event.target.value
    setEmail(value)
    if (!value.length) {
      setNewsletter(false)
    }
    setErrors(reject(errors, { type: 'email' }))
  }

  const handleNewsletterChange = event => setNewsletter(event.target.checked)

  let defaultCountry = { dialCode: '7', iso2: 'ru' }
  let defaultPhone = ''
  if (get(profile, 'phoneIdentity.normalizedNumber')) {
    const getPhone = `+${get(profile, 'phoneIdentity.normalizedNumber')}`
    const phoneNumber = parsePhoneNumberFromString(getPhone)
    if (phoneNumber) {
      defaultCountry = find(CountriesData, { iso2: String(phoneNumber.country).toLowerCase() })
    }
    const formatter = new AsYouType(defaultCountry.iso2.toUpperCase())
    defaultPhone = formatter.input(getPhone.replace(`+${defaultCountry.dialCode}`, ''))
  }

  const [country] = useState(defaultCountry)
  const [phone, setPhone] = useState(defaultPhone)

  const handleSaveClick = async () => {
    setError(null)
    setErrors([])
    if (getCodeEl.current) {
      getCodeEl.current.click()
    }
    try {
      setLoading(true)
      let actions = [patchAccount({ name }), patchEmailIdentities({ email, newsletter })]
      if (phone === ' ') {
        setPhone('')
      }
      if (phone.length === 0 && phone !== defaultPhone) {
        actions.push(deletePhoneNumber())
      }
      const response = await Promise.all(actions)
      await getAccount()
      setLoading(false)
      response.map(item => {
        if (item.payload.errors && item.payload.errors.length > 0) {
          setErrors(errors.concat(item.payload.errors))
        } else if (item.payload.error || item.error) {
          setError(String(item.payload.error || item.payload.message || item.error))
        }
      })
    } catch (error) {
      setLoading(false)
      setError(String(error))
    }
  }

  return (
    <div className="account-block account-block--separated">
      <div className="account-block__title">Личные данные</div>
      <FormInput
        label="Ваше имя"
        value={name}
        onChange={handleNameChange}
        error={find(errors, { type: 'name' })}
        disabled={loading}
        isSettings
      />
      <FormInput
        label="E-mail"
        value={email}
        onChange={handleEmailChange}
        error={find(errors, { type: 'email' })}
        disabled={loading}
        isSettings
        disabledMarginBottom
      />
      <SettingsCheckbox
        label="Хочу получать рассылку"
        checked={newsletter}
        onChange={handleNewsletterChange}
        disabled={!email}
      />
      <SettingsPhone {...{ defaultCountry, country, defaultPhone, phone, setPhone, getCodeRef: getCodeEl }} />
      {error && <div className="account-form__error account-form__error--settings">{error}</div>}
      <Button onClick={handleSaveClick} disabled={loading} isSettings>
        {loading ? <Spinner /> : 'Сохранить изменения'}
      </Button>
    </div>
  )
}

const mapStateToProps = createStructuredSelector({
  profile: profileSelector
})

export default connect(mapStateToProps, { getAccount, patchAccount, patchEmailIdentities, deletePhoneNumber })(
  PersonalDataForm
)
